if (!customElements.get('custom-video')) {
  class CustomVideo extends HTMLElement {
    constructor() {
      super();
      this.initElements();
      this.initEvents();
    }

    // Initialize elements 
    initElements() {
      this.video = this.querySelector('[data-video]');
      this.poster = this.querySelector('[data-poster]');
      this.playButton = this.querySelector('[data-play]');
    }

    // Attach event listeners
    initEvents() {
      this.addEventListener("click", this.togglePlayback.bind(this));
      this.video.addEventListener("pause", this.showPlayButton.bind(this));
      this.video.addEventListener("play", this.hidePlayButton.bind(this));
    }

    // Toggle video playback
    togglePlayback() {
      this.video.paused ? this.playVideo() : this.pauseVideo();
    }

    // Play video and hide UI elements
    playVideo() {
      this.video.play();
      this.hideElement(this.poster);
      this.hideElement(this.playButton);
    }

    //  Pause video and show play button 
    pauseVideo() {
      this.video.pause();
      this.showElement(this.playButton);
    }

    // Show element by removing the 'data-hide' attribute
    showElement(element) {
      element?.removeAttribute('data-hide');
    }

    // Hide element by adding the 'data-hide' attribute
    hideElement(element) {
      element?.setAttribute('data-hide', '');
    }

    // Show play button 
    showPlayButton() {
      this.showElement(this.playButton);
    }

    // Hide play button
    hidePlayButton() {
      this.hideElement(this.playButton);
    }
  }

  customElements.define('custom-video', CustomVideo);
}
